import { Alert } from '@/api'

export function setErrorMessage(alerts: Alert[], obj: any): void {
  alerts.forEach(alert => {
    if (alert.attribute === '') return false
    const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
      str.charAt(1).toUpperCase()
    ) as typeof obj
    const subKey: string = alert.subAttribute.replace(/_./g, str =>
      str.charAt(1).toUpperCase()
    )
    const splitKeys: string[] = (key as string).split('.')

    if (
      obj[key] !== undefined &&
      subKey !== '' &&
      Array.isArray(obj[key]) &&
      Object.prototype.toString
        .call(obj[key][alert.index][subKey])
        .slice(8, -1) === 'Object' &&
      (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
    ) {
      ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
      return
    }

    if (
      obj[key] !== undefined &&
      Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
      (obj[key] as any).hasOwnProperty('errorMessage')
    ) {
      ;(obj[key] as any).errorMessage = alert.message
      return
    }

    if (
      obj[key] !== undefined &&
      subKey === '' &&
      Array.isArray(obj[key]) &&
      alert.index !== -1 &&
      Object.prototype.toString.call(obj[key][alert.index]).slice(8, -1) ===
        'Object' &&
      (obj[key][alert.index] as any).hasOwnProperty('errorMessage')
    ) {
      ;(obj[key][alert.index] as any).errorMessage = alert.message
      return
    }

    if (splitKeys.length > 1 && subKey === '') {
      if (
        obj[splitKeys[0]][splitKeys[1]] !== undefined &&
        Object.prototype.toString
          .call(obj[splitKeys[0]][splitKeys[1]])
          .slice(8, -1) === 'Object' &&
        (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
      }
    }
  })
}
